export class SaurusError extends Error {
    constructor(public readonly message: string, public readonly obj: any) {
        super(message);
        Object.freeze(this);
    }
}
